/* Métodos de pago visibles (pedido Igor 24-oct): en el pie de página y en la tira bajo "Aggiungi al carrello" se añaden American Express y UnionPay (los que tiene activados en Shopify) y se quita Klarna. Los iconos del pie vienen fijos en el código y la tira de la ficha se copia de ellos, así que se completan aquí en el navegador. */
(function () {
  var AMEX = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 24"><rect width="38" height="24" rx="3" fill="#016FD0"/><text x="19" y="15.6" text-anchor="middle" font-family="Arial,Helvetica,sans-serif" font-weight="700" font-size="8.2" fill="#fff" letter-spacing=".4">AMEX</text></svg>';
  var UNION = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 24"><rect x=".5" y=".5" width="37" height="23" rx="3" fill="#fff" stroke="#dcdcdc"/><path d="M10.5 3h8.4l-3 12.5H7.6z" fill="#E21836"/><path d="M17.6 3h8.4l-3 12.5h-8.4z" fill="#00447C"/><path d="M24.7 3h6.6l-3 12.5h-6.6z" fill="#007B84"/><text x="19" y="21" text-anchor="middle" font-family="Arial,Helvetica,sans-serif" font-weight="700" font-size="4.8" fill="#222">UnionPay</text></svg>';
  var CARDS = [
    { alt: 'American Express', src: 'data:image/svg+xml,' + encodeURIComponent(AMEX) },
    { alt: 'UnionPay', src: 'data:image/svg+xml,' + encodeURIComponent(UNION) }
  ];

  function altOf(el) { var i = el.querySelector('img'); return i ? (i.getAttribute('alt') || '') : ''; }

  function complete(items, container, build) {
    if (!items.length) return;
    items.forEach(function (it) { if (/klarna/i.test(altOf(it))) it.remove(); });
    var kept = Array.prototype.filter.call(container.children, function (el) { return el.querySelector && el.querySelector('img'); });
    var ref = kept.filter(function (el) { return /maestro/i.test(altOf(el)); })[0] || kept[kept.length - 1];
    if (!ref) return;
    var after = ref;
    CARDS.forEach(function (c) {
      if (kept.some(function (el) { return altOf(el) === c.alt; })) return;
      var node = ref.cloneNode(true);
      var img = node.querySelector('img');
      img.setAttribute('src', c.src);
      img.setAttribute('alt', c.alt);
      after.insertAdjacentElement('afterend', node);
      after = node;
    });
  }

  function fix() {
    var ul = document.querySelector('.pnc-pay__list');
    if (ul && !ul.dataset.mfPay) {
      ul.dataset.mfPay = '1';
      complete(Array.prototype.slice.call(ul.children), ul);
    }
    var sg = document.querySelector('.mf-sg__c');
    if (sg && sg.children.length && !sg.dataset.mfPay) {
      sg.dataset.mfPay = '1';
      complete(Array.prototype.slice.call(sg.children), sg);
    }
  }

  function start() {
    fix();
    var tries = 0;
    var t = setInterval(function () { fix(); if (++tries > 30) clearInterval(t); }, 300);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', fix);
})();